import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import api from '@/api/robots';

@Module({ namespaced: true })
export default class extends VuexModule {
    @Action
    async list(params: any) {
        return api.list(params)
    }

    @Action
    async add(params: any) {
        return api.add(params)
    }

    @Action
    async edit(params: any) {
        return api.edit(params)
    }

    @Action
    async detail(params: any) {
        return api.detail(params)
    }

    @Action
    async delete(params: any) {
        return api.delete(params)
    }

    @Action
    async services(params: any) {
        return api.services(params)
    }

    @Action
    async reject(params: any) {
        return api.reject(params)
    }
}
